var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5 10.5V6.75C13.5 5.55653 13.9741 4.41193 14.818 3.56802C15.6619 2.72411 16.8065 2.25 18 2.25C19.1935 2.25 20.3381 2.72411 21.182 3.56802C22.0259 4.41193 22.5 5.55653 22.5 6.75V10.5M3.75 21.75H14.25C14.8467 21.75 15.419 21.5129 15.841 21.091C16.2629 20.669 16.5 20.0967 16.5 19.5V12.75C16.5 12.1533 16.2629 11.581 15.841 11.159C15.419 10.7371 14.8467 10.5 14.25 10.5H3.75C3.15326 10.5 2.58097 10.7371 2.15901 11.159C1.73705 11.581 1.5 12.1533 1.5 12.75V19.5C1.5 20.0967 1.73705 20.669 2.15901 21.091C2.58097 21.5129 3.15326 21.75 3.75 21.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.bfc657ce9d2810c483d1993c6b5003c1.svg";
export { ForwardRef as ReactComponent };